const servicesData = {
  en: {
    "marketing-team": {
      title: "Marketing Team",
      subtitle: "Professional growth strategies and campaign execution.",
      hero: "A dedicated marketing team designed to grow your business faster.",
      includes: [
        "Marketing Success Manager",
        "Content Marketing",
        "Social Media Growth",
        "Multi-Channel Advertising",
        "Professional Branding",
        "AI Content Assistant",
      ],
    },

    "ai-automation": {
      title: "AI Automation",
      subtitle: "AI workflows, automations, and business optimization.",
      hero: "Turn repetitive work into intelligent automated systems.",
      includes: [
        "AI Assistants",
        "Workflow Automation",
        "Lead Qualification",
        "CRM Automation",
        "Internal Operations",
        "Reporting",
      ],
    },

    websites: {
      title: "Websites",
      subtitle: "Luxury modern websites built for conversions.",
      hero: "Premium websites designed to convert visitors into customers.",
      includes: [
        "Luxury Design",
        "SEO Optimization",
        "AI Content",
        "Mobile Experience",
        "CRM Integration",
        "Analytics",
      ],
    },

    ecommerce: {
      title: "Ecommerce",
      subtitle: "Online stores and integrated sales systems.",
      hero: "Sell everywhere from one integrated platform.",
      includes: [
        "Storefront Design",
        "Inventory",
        "Payments",
        "Marketplaces",
        "Mobile Commerce",
        "Promotions",
      ],
    },

    payments: {
      title: "Payments",
      subtitle: "Seamless online payment processing.",
      hero: "Accept payments anywhere and grow cash flow faster.",
      includes: [
        "Online Payments",
        "Subscriptions",
        "Invoices",
        "Instant Payouts",
        "Customer Dashboard",
      ],
    },

    crm: {
      title: "CRM",
      subtitle: "Customer relationship management systems.",
      hero: "Organize, automate and scale your business.",
      includes: [
        "Lead Tracking",
        "Tasks",
        "Pipelines",
        "Automation",
        "Projects",
        "Mobile CRM",
      ],
    },

    "forms-leads": {
      title: "Forms Lead",
      subtitle: "Lead generation and client intake forms.",
      hero: "Capture and convert more opportunities.",
      includes: [
        "Lead Forms",
        "Applications",
        "Surveys",
        "Payment Forms",
        "CRM Sync",
      ],
    },

    "email-marketing": {
      title: "Email Marketing",
      subtitle: "Automated email campaigns and funnels.",
      hero: "Build automated customer journeys.",
      includes: [
        "Automation",
        "Templates",
        "Personalization",
        "Analytics",
        "Customer Journeys",
      ],
    },

    listings: {
      title: "Listings",
      subtitle: "Google, Facebook & business directory optimization.",
      hero: "Improve visibility across digital platforms.",
      includes: [
        "Google Profile",
        "Directories",
        "Local SEO",
        "Multi Location",
      ],
    },

    "reputation-review": {
      title: "Reputation Review",
      subtitle: "Management and reputation growth.",
      hero: "Build trust and strengthen your reputation.",
      includes: [
        "Review Monitoring",
        "Trust Widgets",
        "Automation",
        "Protection",
      ],
    },

    social: {
      title: "Social",
      subtitle: "Social media management and scaling.",
      hero: "Build communities and accelerate growth.",
      includes: [
        "Scheduling",
        "AI Content",
        "Analytics",
        "Community Management",
      ],
    },

    content: {
      title: "Content",
      subtitle: "Professional content creation.",
      hero: "Content designed to capture attention.",
      includes: [
        "SEO",
        "Blog Content",
        "AI Optimization",
        "Organic Growth",
      ],
    },

    ads: {
      title: "Ads",
      subtitle: "Paid traffic and multi-channel advertising.",
      hero: "Generate qualified traffic and increase revenue.",
      includes: [
        "Google Ads",
        "Meta Ads",
        "Retargeting",
        "YouTube",
        "Shopping Ads",
      ],
    },

    intelligence: {
      title: "Intelligence",
      subtitle: "Advanced reporting and analytics.",
      hero: "Data transformed into growth decisions.",
      includes: [
        "Dashboards",
        "ROI",
        "Lead Tracking",
        "Analytics",
        "AI Insights",
      ],
    },

    "mobile-app": {
      title: "Mobile App",
      subtitle: "Mobile business management solutions.",
      hero: "Manage your business from anywhere.",
      includes: [
        "CRM",
        "Payments",
        "Notifications",
        "Automation",
      ],
    },
  },

  es: {
    "marketing-team": {
      title: "Equipo de Marketing",
      subtitle:
        "Estrategias profesionales de crecimiento y ejecución de campañas.",
      hero:
        "Un equipo dedicado para acelerar el crecimiento de tu negocio.",
      includes: [
        "Marketing Success Manager",
        "Marketing de Contenidos",
        "Crecimiento en Redes",
        "Publicidad Multicanal",
        "Branding Profesional",
        "Asistente IA",
      ],
    },

    "ai-automation": {
      title: "Automatización IA",
      subtitle:
        "Flujos inteligentes, automatización y optimización empresarial.",
      hero:
        "Transforma procesos repetitivos en sistemas automatizados.",
      includes: [
        "Asistentes IA",
        "Automatización",
        "Calificación de Leads",
        "CRM Automatizado",
        "Operaciones",
        "Reportes",
      ],
    },

    websites: {
      title: "Sitios Web",
      subtitle:
        "Sitios web modernos y premium diseñados para convertir.",
      hero:
        "Experiencias web diseñadas para generar clientes.",
      includes: [
        "Diseño Premium",
        "SEO",
        "Contenido IA",
        "Experiencia Móvil",
        "CRM",
        "Analítica",
      ],
    },

    ecommerce: {
      title: "Ecommerce",
      subtitle:
        "Tiendas online y sistemas integrados de ventas.",
      hero:
        "Vende desde una sola plataforma.",
      includes: [
        "Diseño",
        "Inventario",
        "Pagos",
        "Marketplaces",
        "Comercio Móvil",
        "Promociones",
      ],
    },

    payments: {
      title: "Pagos",
      subtitle:
        "Procesamiento de pagos online.",
      hero:
        "Acepta pagos desde cualquier lugar.",
      includes: [
        "Pagos Online",
        "Suscripciones",
        "Facturación",
        "Pagos Instantáneos",
        "Portal Cliente",
      ],
    },

    crm: {
      title: "CRM",
      subtitle:
        "Sistemas de gestión de relaciones con clientes.",
      hero:
        "Organiza y escala tus operaciones.",
      includes: [
        "Seguimiento",
        "Tareas",
        "Embudos",
        "Automatización",
        "Proyectos",
        "CRM Móvil",
      ],
    },

    "forms-leads": {
      title: "Formularios y Leads",
      subtitle:
        "Captación de clientes y formularios.",
      hero:
        "Convierte visitantes en oportunidades.",
      includes: [
        "Formularios",
        "Solicitudes",
        "Encuestas",
        "Pagos",
        "CRM",
      ],
    },

    "email-marketing": {
      title: "Email Marketing",
      subtitle:
        "Campañas automatizadas y embudos.",
      hero:
        "Automatiza relaciones con clientes.",
      includes: [
        "Automatización",
        "Plantillas",
        "Personalización",
        "Analítica",
        "Embudos",
      ],
    },

    listings: {
      title: "Directorios",
      subtitle:
        "Optimización para Google y directorios.",
      hero:
        "Más visibilidad digital.",
      includes: [
        "Google Business",
        "Directorios",
        "SEO Local",
        "Multi Sede",
      ],
    },

    "reputation-review": {
      title: "Reputación",
      subtitle:
        "Gestión y crecimiento de reputación.",
      hero:
        "Genera confianza online.",
      includes: [
        "Monitoreo",
        "Widgets",
        "Automatización",
        "Protección",
      ],
    },

    social: {
      title: "Redes Sociales",
      subtitle:
        "Gestión y crecimiento de redes.",
      hero:
        "Escala tu presencia digital.",
      includes: [
        "Programación",
        "Contenido IA",
        "Analítica",
        "Comunidad",
      ],
    },

    content: {
      title: "Contenido",
      subtitle:
        "Creación de contenido profesional.",
      hero:
        "Contenido diseñado para convertir.",
      includes: [
        "SEO",
        "Blogs",
        "Optimización IA",
        "Crecimiento Orgánico",
      ],
    },

    ads: {
      title: "Publicidad",
      subtitle:
        "Tráfico pago y campañas multicanal.",
      hero:
        "Genera ventas con publicidad.",
      includes: [
        "Google Ads",
        "Meta Ads",
        "Remarketing",
        "YouTube",
        "Shopping",
      ],
    },

    intelligence: {
      title: "Inteligencia",
      subtitle:
        "Analítica y reportes avanzados.",
      hero:
        "Datos convertidos en decisiones.",
      includes: [
        "Dashboards",
        "ROI",
        "Leads",
        "Analítica",
        "IA",
      ],
    },

    "mobile-app": {
      title: "Aplicación Móvil",
      subtitle:
        "Soluciones móviles empresariales.",
      hero:
        "Gestiona tu negocio desde cualquier lugar.",
      includes: [
        "CRM",
        "Pagos",
        "Notificaciones",
        "Automatización",
      ],
    },
  },
};

export default servicesData;